/**
 * RESPONSIBILITY: draw a @List column — a repeatable inside a row.
 *
 * The rows it draws are the same Repeatable the outer list uses, so a nested list is the
 * list an editor already knows: same summary, same up/down/remove, same add. It was
 * absent until now because "a list inside a row" was a design question rather than a
 * missing lookup entry, and the answer is that depth changes nothing about what a
 * repeatable is.
 *
 * It takes the whole line. A column that contains rows cannot share one.
 */
import { Repeatable } from './repeatable';
import type { Cell, CellProps } from './cell-types';

function ListCell({ field, value, onChange, id, root }: CellProps) {
  const rows = Array.isArray(value) ? (value as Record<string, unknown>[]) : [];

  return (
    <div className="ctl-cell-list">
      <Repeatable
        path={id}
        fields={field.itemFields ?? []}
        rows={rows}
        root={root}
        maxItems={field.maxItems}
        // Not the field's label: the column above already says which list this is, and
        // "+ Bands down the page" reads as though one press adds several.
        addLabel="Add"
        onChange={(next) => onChange(next)}
      />
    </div>
  );
}

export const listCell: Cell = { render: ListCell, basis: () => '100%' };
